export { default as Stats } from "./lib/stats.js";
export { default as Stat } from "./lib/stat.js";
// UTILITIES
export { default as _getHiResTimestamp } from "./utils/hi-res-timestamp.js";
//# sourceMappingURL=index.js.map